











































helpers = require('../../helpers.coffee')

view_model =
  components:
    listItem: require('./list_item.vue')
    newTemplateCategory: require('./new.vue')
  data: ->
    template_categories: []
    name: ''
    editing: null
    loading: true
    selected_template_category: {}

  methods:
    loadTemplateCategories: ->
      new TemplateCategoriesResource(Session.current_company.id).index(@loadTemplateCategoriesSuccess)

    loadTemplateCategoriesSuccess: (data) ->
      @loading = false
      @template_categories = data.template_categories

    toggleEditClass: (id) ->
      if @editing && @editing.id == id then '' else 'hidden'

    updatedTemplateCategory: (template_category) ->
      index = @template_categories.findIndex(template_category.id)
      @template_categories.replaceById(template_category)

    createdTemplateCategory: (template_category) ->
      @template_categories.unshift(template_category)

    openDestroyConfirmationModal: (template_category) ->
      @selected_template_category = template_category
      EventsBus.$emit 'confirm-modal-show', id: 'confirm-destroy-template-category'

    destroyTemplateCategory: ->
      Loader.on()
      new TemplateCategoriesResource().destroy(@successDestroyTemplateCategory, @unknownError, id: @selected_template_category.id)

    successDestroyTemplateCategory: ->
      Loader.off()
      @template_categories.remove(@selected_template_category.id)
      @$store.commit 'removeTemplateCategory', @selected_template_category
      alertify.success('Categoria excluída com sucesso')
      IntercomCtrl.trackEvent(
        'Excluiu uma categoria de template',
        { id: @selected_template_category.id, 'Nome': @selected_template_category.name }
      )

  beforeCreate: ->
    if Session.current_user.isSeller() || Session.current_user.isMonitoringManager()
      @$router.push('/configuracoes/perfil')

  created: ->
    @loadTemplateCategories()

exports.default = helpers.vue_include(view_model, helpers.form)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/template_categories/index.vue